import React, { useState } from "react";
import useConsent from "./useConsent";
import PreferencesPanel from "./PreferencesPanel";

const ConsentBanner = () => {
  const { consentState, acceptAll, rejectAll, openPreferences, isPanelOpen, gpcDetected } = useConsent();
  const [dismissed, setDismissed] = useState(false);

  return (
    <>
      {gpcDetected && (
        <div
          role="status"
          aria-live="polite"
          className="fixed bottom-0 left-0 w-full z-[100000] bg-dark-light text-white text-sm text-center py-2 px-4"
        >
          Your Global Privacy Control signal has been honoured. Non-essential cookies are disabled.
        </div>
      )}

      {!gpcDetected && consentState === null && !dismissed && !isPanelOpen && (
        <div
          role="dialog"
          aria-modal="true"
          aria-label="Cookie consent"
          className="fixed bottom-3 left-1/2 -translate-x-1/2 z-[100000] w-[calc(100vw-24px)] max-w-6xl bg-dark rounded-2xl shadow-card px-4 py-4 sm:px-6"
        >
          <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">

            {/* Top row on mobile: icon + title + close */}
            <div className="flex items-start gap-3 sm:contents">

              {/* Icon */}
              <div className="shrink-0 w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-primary-soft flex items-center justify-center">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5"/>
                  <path d="M8.5 8.5v.01"/>
                  <path d="M16 15.5v.01"/>
                  <path d="M12 12v.01"/>
                </svg>
              </div>

              {/* Text */}
              <div className="flex-1 min-w-0">
                <p className="font-heading font-semibold text-white text-sm mb-0.5">Cookie Prefrences</p>
                <p className="text-white text-sm leading-relaxed">
                  We use cookies to personalise your experience, analyse site traffic. You can choose which cookies to allow.{" "}
                  <a href="/cookie-policy" className="text-primary underline hover:text-primary-hover transition-colors">
                    Learn more
                  </a>
                </p>
              </div>

              {/* Close — visible on mobile top-right */}
              <button
                onClick={() => setDismissed(true)}
                aria-label="Close cookie banner"
                className="sm:hidden shrink-0 text-text-muted hover:text-white transition-colors text-base leading-none p-1 -mt-0.5"
              >
                &#x2715;
              </button>
            </div>

            {/* Buttons */}
            <div className="flex items-center gap-2 shrink-0 sm:ml-auto">
              <button
                onClick={rejectAll}
                className="flex-1 sm:flex-none px-3 sm:px-4 py-2 rounded-lg text-xs font-medium text-white border border-dark-light bg-transparent hover:border-surface-border transition-colors"
              >
                Reject All
              </button>
              <button
                onClick={openPreferences}
                className="flex-1 sm:flex-none px-3 sm:px-4 py-2 rounded-lg text-xs font-medium text-white border border-dark-light bg-transparent hover:border-surface-border transition-colors"
              >
                Manage Prefrences
              </button>
              <button
                onClick={acceptAll}
                className="flex-1 sm:flex-none px-3 sm:px-4 py-2 rounded-lg text-xs font-semibold text-white bg-primary hover:bg-primary-hover transition-colors"
              >
                Accept All
              </button>
            </div>

            {/* Close — hidden on mobile, visible on desktop */}
            <button
              onClick={() => setDismissed(true)}
              aria-label="Close cookie banner"
              className="hidden sm:block shrink-0 text-text-muted hover:text-white transition-colors text-base leading-none p-1"
            >
              &#x2715;
            </button>

          </div>
        </div>
      )}

      <PreferencesPanel />
    </>
  );
};

export default ConsentBanner;